import { NgModule } from '@angular/core';
import { WithdrawalInteracPage } from './withdrawal-interac';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
@NgModule({
  declarations: [
    WithdrawalInteracPage,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
})
export class WithdrawalInteracModule {}
